
export const NAV_IDS = {
	READY_TO_CLOSE: "sb-nav-ready-2-close",
	READY_TO_CLOSE_SEARCH: "sb-nav-ready-2-close-search",
	FILE_MAINTENANCE: "sb-nav-file-maintenance",
	FILE_MAINTENANCE_DASHBOARD: "sb-nav-file-maintenance-dashboard",
	FILE_MAINTENANCE_INVITATIONS: "sb-nav-file-maintenance-invitations",
	FILE_MAINTENANCE_DOCUMENTS: "sb-nav-file-maintenance-documents",
	FILE_MAINTENANCE_SNUTASKS: "sb-nav-file-maintenance-snuTasks",
    FILE_MAINTENANCE_OVERRIDES: "sb-nav-file-maintenance-overrides",
    FILE_MAINTENANCE_OVERRIDES_FILE: "sb-nav-file-maintenance-overrides-file",
    FILE_MAINTENANCE_OVERRIDES_CONTACTS: "sb-nav-file-maintenance-overrides-contacts",
    FILE_MAINTENANCE_OVERRIDES_STAFF: "sb-nav-file-maintenance-overrides-staff",
    FILE_MAINTENANCE_OVERRIDES_BUYERSELLER: "sb-nav-file-maintenance-overrides-buyerseller",
    FILE_MAINTENANCE_OVERRIDES_PROPERTY: "sb-nav-file-maintenance-overrides-property",
    FILE_MAINTENANCE_OVERRIDES_WIRE_INSTRUCTIONS: "sb-nav-file-maintenance-overrides-wire-instructions",
	CONFIGURATION: "sb-nav-configuration"
};